export default __webpack_public_path__ + "static/media/Twin House main Cover.b4e78d78.jpg";